import styles from './license-usage-grid.module.scss';
import { DateRange } from '@mui/x-date-pickers-pro/DateRangePicker';
import { CreateHeaders, HeaderSizeEnum, TableProductsFilterProps, minuteToHourConverter, textHeader } from '@frontend-workspace/react-shared-lib';
import { ILicenseUtilization } from '../../_models/license-utilization';
import FullTable from '../../full-table/full-table';
import { useTranslation } from 'react-i18next';
import { ValueFormatterParams } from 'ag-grid-community';

/* eslint-disable-next-line */
export interface LicenseUsageGridProps {
}
export function LicenseUsageGrid(props: LicenseUsageGridProps) {
  const { t } = useTranslation();
  const minutesRenderer = (params: ValueFormatterParams) => minuteToHourConverter(params.value * 60, t("standard.noTimeSpent"));

  return (
    <FullTable
      headers={CreateHeaders([
        textHeader("licenseNumber", t("standard.licenseNumber"), HeaderSizeEnum.MEDIUM),
        textHeader("companyName", t("standard.company"), HeaderSizeEnum.EXTRA_LARGE),
        textHeader("companyNumber", t("standard.companyNumber"), HeaderSizeEnum.MEDIUM),
        textHeader("product", t("standard.product"), HeaderSizeEnum.EXTRA_LARGE),
        textHeader("licenseType", t("standard.licenseModel")),
        textHeader("newLicensing", t("standard.newLicensingSystem")),
        textHeader("seats", t("standard.seats"), HeaderSizeEnum.MEDIUM, {
          cellStyle: { justifyContent: 'right' },
          headerClass: "ag-right-aligned-header"
        }),
        textHeader("usersWithAccesses", t("standard.accesses"), HeaderSizeEnum.MEDIUM, {
          cellStyle: { justifyContent: 'right' },
          headerClass: "ag-right-aligned-header"
        }),
        textHeader("usersWithLogons", t("licenseUsageGrid.users"), HeaderSizeEnum.MEDIUM, {
          cellStyle: { justifyContent: 'right' },
          headerClass: "ag-right-aligned-header"
        }),
        textHeader("logons", t("standard.logons"), HeaderSizeEnum.MEDIUM, {
          cellStyle: { justifyContent: 'right' },
          headerClass: "ag-right-aligned-header"
        }),
        textHeader("logonsPerSeat", t("licenseUsageGrid.logonsPerSeat"), HeaderSizeEnum.MEDIUM, {
          cellStyle: { justifyContent: 'right' },
          headerClass: "ag-right-aligned-header"
        }),
        textHeader("hours", t("standard.hoursLoggedOn"), HeaderSizeEnum.MEDIUM, {
          renderer: minutesRenderer,
          cellStyle: { justifyContent: 'right' },
          headerClass: "ag-right-aligned-header"
        }),
        textHeader("hoursPerSeat", t("standard.hoursPerSeat"), HeaderSizeEnum.MEDIUM, {
          renderer: minutesRenderer,
          cellStyle: { justifyContent: 'right' },
          headerClass: "ag-right-aligned-header"
        }),
      ])}
      tableConfigName='licenseUsage'
      url='reports/license-Utilization'
    />
  )
}

export default LicenseUsageGrid;